import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App';
import './i18n.js';
import { BrowserRouter as Router } from 'react-router-dom';
import ReactGA from 'react-ga4';

import 'bootstrap/dist/css/bootstrap.min.css';

const GA_ID = process.env.REACT_APP_GA_ID;

// Initialize Google Analytics 4 only when user consents
window.initGA4 = () => {
  ReactGA.initialize(GA_ID, {
    gtagOptions: {
      send_page_view: false, // We'll handle page views manually in App.js
    },
  });
};

// Check if user has already consented
const cookieConsent = localStorage.getItem('cookieConsent');
if (cookieConsent === 'true') {
  window.initGA4();
}

// Disable browser's automatic scroll restoration
if ('scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual';
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Router>
      <App />
    </Router>
  </React.StrictMode>
);